module.exports = __webpack_public_path__ + "img/pequenos_electrodomesticos.1e814d8b.png";